import React from 'react';
import './home.scss';

const Home = () => (
  <main className="home">
    <div className="home__content">
      <aside className="home__notice" aria-label="Showcase disclaimer">
        <p>This application demonstrates what Openlexia could offer. It is an early showcase, not a finished product ready for use.</p>
      </aside>

      <header className="home__introduction">
        <h1>Openlexia</h1>
        <p className="home__tagline">A more connected world starts with a shared language.</p>
        <p>People move across borders to work, study, join family, and explore new possibilities. Learning a language helps turn a new place into a home, opens professional opportunities, and brings people closer together.</p>
        <p>Openlexia is a non-profit initiative to make high-quality language education freely accessible to everyone, whatever their income or circumstances. Inspired by Wikipedia, it aims to bring educators and volunteers together to build structured courses combining lessons, audio, and interactive exercises.</p>
      </header>

      <section className="home__section" aria-labelledby="home-audience">
        <h2 id="home-audience">Who is it for?</h2>
        <ul className="home__audiences">
          <li className="home__audience"><strong>People building a life in a new country</strong>, who want to communicate confidently in everyday situations.</li>
          <li className="home__audience"><strong>Professionals, students, and travellers</strong>, preparing for opportunities and experiences across borders.</li>
          <li className="home__audience"><strong>Anyone curious about another language</strong>, learning at their own pace, whatever their budget.</li>
          <li className="home__audience"><strong>Teachers, volunteers, and organizations</strong>, creating and improving resources for a shared learning community.</li>
        </ul>
        <p>Courses will initially focus on European languages, with the ambition to expand worldwide.</p>
      </section>

      <section className="home__section" aria-labelledby="home-process">
        <h2 id="home-process">How will it work?</h2>
        <p>Learners will follow structured courses at their own pace, using clear explanations, audio, and interactive exercises.</p>
        <p>Contributors will create and improve lessons through a shared editing format. AI-assisted drafting will support their work, with human review to check quality and accuracy. Publishing will initially be limited to selected contributors as review and moderation processes develop.</p>
      </section>

      <section className="home__section" aria-labelledby="home-landscape">
        <h2 id="home-landscape">What Sets Openlexia Apart in the Language-Learning Landscape</h2>
        <p>Within the language-learning landscape, Openlexia aims to offer a donation-funded alternative to freemium platforms. Its commitment is simple: complete courses freely accessible to everyone, with no paid tier, advertising, login, or subscription required. Open-source software and openly licensed learning materials let the community reuse, adapt, and improve what it builds.</p>
        <p>Openlexia does not aim to introduce another AI conversational agent to the language-learning landscape. It aims to be an open digital language textbook: structured courses with a clear path and dependable lessons you can browse, bookmark, and revisit. It gives learners and teachers a stable reference for building knowledge step by step. An AI conversational agent could also use it, just as a teacher uses a textbook.</p>
      </section>

      <section className="home__section" aria-labelledby="home-openness">
        <h2 id="home-openness">Open by design</h2>
        <p>The software will be open source, and educational materials openly licensed for reuse and adaptation.</p>
        <p>Funded by donations and built by volunteers, Openlexia aims to become a lasting public resource: language education built together, available to everyone.</p>
      </section>
    </div>
  </main>
);

export default Home;
